// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"825386d9","629":"99fdeed3"}[chunkId] + ".chunk.js";
};